import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Basketball, List, X } from "@phosphor-icons/react";

const links = [
  { to: "/", label: "Home" },
  { to: "/schedule", label: "Schedule" },
  { to: "/teams", label: "Teams" },
  { to: "/standings", label: "Standings" },
  { to: "/playoffs", label: "Playoffs" },
  { to: "/shootout", label: "Shootout" },
  { to: "/stats", label: "Stats" },
  { to: "/player-of-the-week", label: "Awards" },
  { to: "/highlights", label: "Highlights" },
  { to: "/rules", label: "IEFSC Rules" },
  { to: "/register", label: "Register" },
  { to: "/waiver", label: "Waiver" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group shrink-0">
          <img src="/iefsc-logo.png" alt="IEFSC" className="w-10 h-10 object-contain group-hover:scale-110 transition-transform duration-200" />
          <span className="font-display text-3xl leading-none text-[#FF5722]">IEFSC</span>
        </Link>

        <nav className="hidden xl:flex items-center gap-0.5">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-2 py-2 text-[13px] font-semibold uppercase tracking-wide whitespace-nowrap transition-all duration-200 ${
                pathname === l.to ? "text-[#FF5722]" : "text-white/70 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/admin"
            data-testid="nav-admin"
            className="ml-2 px-3 py-2 text-[13px] font-bold uppercase tracking-wide whitespace-nowrap border border-white/20 hover:border-[#FF5722] hover:text-[#FF5722] transition-all duration-200"
          >
            Admin
          </Link>
        </nav>

        <button data-testid="mobile-menu-toggle" className="xl:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X size={28} /> : <List size={28} />}
        </button>
      </div>

      {open && (
        <nav className="xl:hidden border-t border-white/10 bg-black px-6 py-4 flex flex-col gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={`px-2 py-3 text-base font-semibold uppercase tracking-wide ${
                pathname === l.to ? "text-[#FF5722]" : "text-white/80"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/admin" onClick={() => setOpen(false)} className="px-2 py-3 text-base font-bold uppercase text-[#FF5722]">
            Admin
          </Link>
        </nav>
      )}
    </header>
  );
};
